export const setAlertMessage = (
  descKey: string,
  generateAlert: (alert?: any) => void,
  options?: any,
) => {
  generateAlert({
    description: descKey,
    showCloseBtn: true,
    ...options,
  });
};

// export deep clone function
// export const deepClone = (obj: object) => JSON.parse(JSON.stringify(obj));
export const deepClone = (obj: {}) => JSON.parse(JSON.stringify(obj));

export function paginate(array: any[] | undefined = [], pageSize: number) {
  const pageCount = Math.ceil(array?.length / pageSize);
  return Array.from({ length: pageCount }, (_, index) =>
    array?.slice(index * pageSize, (index + 1) * pageSize),
  );
}

export function getListBySearch(
  list: object[] | undefined = [],
  searchValue: string,
  /**
   * An array of specific "keys" or any "key" (default)
   * to compare its value to the searchValue.
   * Example: ['name', 'url']
   * @default undefined
   */
  searchByKeys?: string[] | undefined,
) {
  return list?.filter((item) => {
    const listOfKeys = searchByKeys ?? Object.keys(item);

    return listOfKeys.some((key) =>
      // @ts-expect-error
      item[key]?.toString().toLowerCase().includes(searchValue.toLowerCase()),
    );
  });
}

export const isValueEmpty = (value?: string | number | null) => {
  if (value == null) {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim() === '';
  }

  return false;
};
